import React from 'react';

export function SessionPlanningPage() {
  return (
    <div className="flex h-full">
      <div className="w-1/2 border-r p-4">
        <h2 className="text-xl font-bold">Current Plan</h2>
        {/* CurrentPlan component will go here */}
      </div>
      <div className="w-1/2 p-4">
        <h2 className="text-xl font-bold">Exercise Library</h2>
        {/* ExerciseLibrary component will go here */}
      </div>
    </div>
  );
}